import home from "templates/home/home";
import dynamic from "templates/dynamic/dynamic";
import articles from "templates/articles/articles";
import articleDetail from "templates/article-detail/article-detail";
import contact from "templates/contact/contact";
import faq from "templates/faq/faq";

export default [home, articles, articleDetail, dynamic, contact, faq];
